import {
  EmailIcon,
  PdfIcon,
  CsvIcon,
  DocxIcon,
  Mp4Icon,
  XlsxIcon,
  TxtIcon,
  AviIcon,
  MsgIcon,
  ZipIcon,
} from './FileIcons';

// Helper function to get icon by file extension
export function getFileIconByName(fileName: string): JSX.Element {
  const ext = fileName.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'pdf':
      return <PdfIcon />;
    case 'docx':
    case 'doc':
      return <DocxIcon />;
    case 'xlsx':
    case 'xls':
      return <XlsxIcon />;
    case 'csv':
      return <CsvIcon />;
    case 'eml':
      return <EmailIcon />;
    case 'msg':
      return <MsgIcon />;
    case 'mp4':
      return <Mp4Icon />;
    case 'avi':
      return <AviIcon />;
    case 'txt':
      return <TxtIcon />;
    case 'zip':
      return <ZipIcon />;
    default:
      return <DocxIcon />;
  }
}

// Helper function to get file type from extension
export function getFileType(
  fileName: string,
): 'email' | 'pdf' | 'csv' | 'docx' | 'mp4' | 'xlsx' | 'txt' | 'avi' | 'msg' {
  const ext = fileName.split('.').pop()?.toLowerCase();

  switch (ext) {
    case 'pdf':
      return 'pdf';
    case 'docx':
    case 'doc':
      return 'docx';
    case 'xlsx':
    case 'xls':
      return 'xlsx';
    case 'csv':
      return 'csv';
    case 'eml':
      return 'email';
    case 'msg':
      return 'msg';
    case 'mp4':
      return 'mp4';
    case 'avi':
      return 'avi';
    case 'txt':
      return 'txt';
    default:
      return 'docx';
  }
}
